<template>
  <datepicker :value="filter.buckets[0].value"
    :name="filterName"
    :typeable="false"
    :format="filter.format"
    :minimumView="minValue"
    :maximumView="'year'"
    :placeholder="`Select a ${$options.filters.humanize(filterName)}`"
    :clear-button="filter.buckets[0].active"
    :clear-button-icon="`fa fa-times`"
    :bootstrap-styling="true"
    class="py-2 px-3"
    :class="{'t-placeholder-fake' : !filter.buckets[0].active}"
    @selected="handleDatepicker(filter.buckets[0], filterName, ...arguments)">
  </datepicker>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'bucketDate',
  components: {
    Datepicker
  },
  props: {
    filterName: {
      type: String,
      required: true
    },
    filter: {
      type: Object,
      required: true
    }
  },
  created () {
    if (this.filter.format !== 'yyyy-MM') this.minValue = 'day'
  },
  data () {
    return {
      minValue: 'month'
    }
  },
  methods: {
    handleDatepicker (bucket, filterName, date) {
      let formattedDate = (date !== null && date !== '') ? moment(date).format(this.filter.format.toUpperCase()) : ''
      bucket.label = formattedDate
      bucket.value = formattedDate
      !this.isEmpty(formattedDate) ? bucket.active = true : bucket.active = false
      this.$emit('bucketDateToggled', bucket, filterName)
    }
  }
}
</script>
